import React from 'react'
// import 'react-slideshow-image/dist/styles.css'
import pic1 from "../images/slider1.jpg"
import pic2 from "../images/slider3.jpg"
import pic3 from "../images/slider2.jpg"
import pic4 from "../images/banner1.jpg"
import { Fade } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'


function Header() {
    return (
        <>
            <div className="slide-container" >
                <Fade >
                    <div className="each-fade">
                        <div className="image-container">
                            <img src={pic3} />
                        </div>
                    </div>

                    <div className="each-fade">
                        <div className="image-container">
                            <img src={pic2} />
                        </div>
                    </div>

                    <div className="each-fade">
                        <div className="image-container">
                            <img src={pic1} />
                        </div>
                    </div>

                    <div className="each-fade">
                        <div className="image-container">
                            <img src={pic1} />
                        </div>
                    </div>


                </Fade>
            </div>


        </>
    )
}

export default Header
